import apiService from "../../api/api.service";
import { AgreementsResponse } from "./agreements.types";

export const fetchAgreements = () => {
  return apiService.get<AgreementsResponse>("/general/register-agreements");
};
